module.exports = __webpack_public_path__ + "img/empty.ddc9a967.png";